import $ from 'jquery'
import 'slick-carousel'

/**
 * Slick-Slider initialisieren.
 * Settings über Modifier-Klassen (.slick--banner, .slick--1, …).
 * Hinweis: Slick basiert auf jQuery – unser Wrapper bleibt Vanilla.
 */
export function slider() {
	const sliders = document.querySelectorAll('.slick')
	if (!sliders.length) return

	sliders.forEach((el) => {
		const $el = $(el)

		if (el.classList.contains('slick--banner')) {
			$el.slick({
				infinite: true,
				slidesToShow: 1,
				slidesToScroll: 1,
				dots: true,
				arrows: true,
				adaptiveHeight: true,
				autoplay: true,
				autoplaySpeed: 6000,
				responsive: [
					{
						breakpoint: 768,
						settings: {
							arrows: false
						}
					}
				]
			})
		} else if (el.classList.contains('slick--auto')) {
			$el.slick({
				infinite: true,
				slidesToShow: 1,
				slidesToScroll: 1,
				fade: true,
				autoplay: true,
				autoplaySpeed: 4000,
				arrows: true,
				dots: true
			})
		} else if (el.classList.contains('slick--1')) {
			$el.slick({
				infinite: true,
				slidesToShow: 1,
				slidesToScroll: 1,
				arrows: false,
				dots: true,
				adaptiveHeight: true
			})
		} else if (el.classList.contains('slick--2')) {
			$el.slick({
				infinite: true,
				slidesToShow: 2,
				slidesToScroll: 2,
				arrows: true,
				dots: true,
				responsive: [
					{
						breakpoint: 840,
						settings: {
							slidesToShow: 1,
							slidesToScroll: 1,
							arrows: true
						}
					}
				]
			})
		} else if (el.classList.contains('slick--3')) {
			$el.slick({
				infinite: true,
				slidesToShow: 3,
				slidesToScroll: 3,
				arrows: true,
				dots: true,
				responsive: [
					{
						breakpoint: 1280,
						settings: {
							slidesToShow: 2,
							slidesToScroll: 2
						}
					},
					{
						breakpoint: 840,
						settings: {
							slidesToShow: 1,
							slidesToScroll: 1,
							arrows: true
						}
					}
				]
			})
		} else if (el.classList.contains('slick--4')) {
			$el.slick({
				infinite: true,
				slidesToShow: 4,
				slidesToScroll: 4,
				arrows: true,
				dots: true,
				responsive: [
					{
						breakpoint: 1179, // iPad Air Landscape
						settings: {
							slidesToShow: 3,
							slidesToScroll: 3,
							arrows: true
						}
					},
					{
						breakpoint: 768,
						settings: {
							slidesToShow: 2,
							slidesToScroll: 2,
							arrows: true
						}
					}
				]
			})
		} else {
			$el.slick({
				slidesToShow: 1,
				slidesToScroll: 1,
				adaptiveHeight: true,
				arrows: true,
				dots: true
			})
		}
	})
}
